import { useCallback } from 'react';
import apiInstance from '../services/apiInstance';

export const useAuthActions = () => {
    const loginUser = useCallback(async (credentials: any) => {
        const response = await apiInstance.post('/login-backend', credentials);
        return response.data;
    }, []);

    const signupUser = useCallback(async (userData: any) => {
        const response = await apiInstance.post('/signup-backend', userData);
        return response.data;
    }, []);

    const getLoggedInUser = useCallback(async () => {
        const response = await apiInstance.get('/get-loggedin-user');
        return response.data;
    }, []);

    return { loginUser, signupUser, getLoggedInUser };
};
